const init_page_index = function () {
  (function () {
    var headerIndex = $(".pageindex#pageindex")

    //Get the max header level from the maxlevel attribute of the index element
    //using a jQuery selector get all header elements up to the max level keeping the original order
    //For each element, get it's type using $.prop('nodeName') to know if it is h1, h2 or h3
    //insert an invisible span with an incremential id inside the element
    //Then, create a link to the span and insert it insite indexContainer using the text of the element as the link text
    //Indent the link according to it's type

    var selector = "";
    var maxLevel = headerIndex.attr("maxlevel");
    for (var i = 1; i <= maxLevel; i++) {
      if (i > 1) {
        selector += ",";
      }
      selector += "h" + i;
    }
    var headers = $(".page__content").find(selector);     

    //keep the last of each header type so we can append childs to it
    var lastHeaders = [];
    headers.each(function(index) {
      var headerType = $(this).prop('nodeName');
      var headerLevel = parseInt(headerType[1]);
      
      //get the last header of the previous level as the parent element. If null use the index container
      var parentElement = headerIndex;
      if (headerLevel > 1 && lastHeaders[headerLevel - 2]) {
        parentElement = lastHeaders[headerLevel - 2];
      }
      
      //if parentElement does not contail a UL, appen one
      if (!parentElement.find("ul").length) {
        var ulElement = $("<ul style='display: none'></ul>");
        var toggleElement = $("<span class='index_toggle'>+</span>");
        toggleElement.click(function() {
          ulElement.toggle();
          if (toggleElement.text() == "+") {
            toggleElement.text("-");
          } else {
            toggleElement.text("+");
          }
        });
        parentElement.append(toggleElement);
        parentElement.append(ulElement);
      }

      //get the list element from the parent
      var listElement = parentElement.find("ul").first();

      //create the anchor
      var headerId = "header" + index;
      $(this).prepend("<span id='" + headerId + "' class='index_anchor'></span>");
            
      //create the link and insert it into the index
      var headerText = $(this).text();   
      var link = "<a href='#" + headerId + "'>" + headerText + "</a>";
      var linkContainer = $("<li class='indent" + headerLevel + "'>" + link + "</li>");
      listElement.append(linkContainer);

      //set the current link container as the last hrader of it's type
      lastHeaders[headerLevel - 1] = linkContainer;
    });    

  })();
}

jQuery("document").ready(init_page_index);

/**
 * Expand all collapsible sections on product pages by default
 * - Expandable content (View more/less)
 * - Collapsible cards (What's Included, Dimensions, etc.)
 */
const init_expanded_sections = function() {
  // Only run on product pages
  if (!document.querySelector('[data-section-type="product"]') && !document.querySelector('.product-block-list')) {
    return;
  }

  // 1. Expand the main description expandable content
  document.querySelectorAll('.expandable-content').forEach(function(section) {
    var toggleButton = section.querySelector('.expandable-content__toggle');
    if (!toggleButton) return;

    // Check if content is expandable (scrollHeight > clientHeight means content is truncated)
    if (section.scrollHeight > section.clientHeight || section.classList.contains('expandable-content--expandable')) {
      // Set expanded state
      section.setAttribute('aria-expanded', 'true');
      section.setAttribute('expanded', 'true');
      section.style.maxHeight = 'none';

      // Update button state and text
      toggleButton.setAttribute('aria-expanded', 'true');
      var toggleText = toggleButton.querySelector('.expandable-content__toggle-text');
      if (toggleText) {
        toggleText.innerHTML = toggleText.getAttribute('data-view-less') || 'View less';
      }

      // Add margin for the button positioning
      if (toggleButton.previousElementSibling) {
        toggleButton.previousElementSibling.style.marginBottom = toggleButton.clientHeight + 'px';
      }
    }
  });

  // 2. Expand all collapsible card sections
  // Video sections use Intersection Observer for lazy loading
  var videoSectionsToObserve = [];

  document.querySelectorAll('.card__collapsible-button[data-action="toggle-collapsible"]').forEach(function(button) {
    var contentId = button.getAttribute('aria-controls');
    var content = document.getElementById(contentId);

    if (!content) return;

    // Disable accordion behavior - allow multiple sections to be open at once
    button.setAttribute('data-close-siblings', 'false');

    // Check if this section contains video wrappers (WiBot injects videos on click)
    var hasVideos = content.querySelector('.video-wrapper') !== null;

    if (hasVideos) {
      // Queue video sections for lazy loading when scrolled into view
      videoSectionsToObserve.push({ button: button, content: content });
    } else {
      // Non-video sections: trigger click immediately
      if (typeof jQuery !== 'undefined') {
        jQuery(button).trigger('click');
      } else {
        button.click();
      }
    }

    // Set expanded state on button
    button.setAttribute('aria-expanded', 'true');

    // Expand the content
    if (content.hasAttribute('aria-hidden')) {
      content.setAttribute('aria-hidden', 'false');
    }

    // Set height to auto (content will be visible)
    content.style.height = 'auto';

    // Trigger lazy loading for non-video lazy elements
    content.querySelectorAll('iframe[data-src], video[data-src], img.lazyload').forEach(function(lazyEl) {
      if (lazyEl.hasAttribute('data-src') && !lazyEl.getAttribute('src')) {
        lazyEl.setAttribute('src', lazyEl.getAttribute('data-src'));
        lazyEl.removeAttribute('data-src');
      }
      if (typeof lazySizes !== 'undefined' && lazySizes.loader && lazyEl.classList.contains('lazyload')) {
        lazySizes.loader.unveil(lazyEl);
      }
    });
  });

  // 3. Set up Intersection Observer for video sections - load videos when scrolled near
  if (videoSectionsToObserve.length > 0 && 'IntersectionObserver' in window) {
    var videoObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var button = entry.target.videoButton;
          var content = entry.target;

          // Trigger click to inject video iframes (WiBot handler)
          if (typeof jQuery !== 'undefined') {
            jQuery(button).trigger('click');
          } else {
            button.click();
          }

          // Re-apply expanded state after click
          button.setAttribute('aria-expanded', 'true');
          if (content.hasAttribute('aria-hidden')) {
            content.setAttribute('aria-hidden', 'false');
          }
          content.style.height = 'auto';

          // Stagger iframe loading to prevent YouTube 502 errors
          setTimeout(function() {
            staggerIframeLoading(content);
          }, 100);

          // Stop observing this section
          videoObserver.unobserve(content);
        }
      });
    }, {
      rootMargin: '200px 0px', // Load videos 200px before they enter viewport
      threshold: 0
    });

    videoSectionsToObserve.forEach(function(section) {
      // Store button reference on the content element
      section.content.videoButton = section.button;
      videoObserver.observe(section.content);
    });
  } else if (videoSectionsToObserve.length > 0) {
    // Fallback for browsers without IntersectionObserver: load immediately
    videoSectionsToObserve.forEach(function(section) {
      if (typeof jQuery !== 'undefined') {
        jQuery(section.button).trigger('click');
      } else {
        section.button.click();
      }
      section.button.setAttribute('aria-expanded', 'true');
      setTimeout(function() {
        staggerIframeLoading(section.content);
      }, 100);
    });
  }
};

/**
 * Stagger loading of multiple iframes to prevent YouTube 502 errors
 * Temporarily removes src from all iframes, then loads them one by one
 */
function staggerIframeLoading(container) {
  var iframes = container.querySelectorAll('iframe[src*="youtube"], iframe[src*="youtu.be"]');

  if (iframes.length <= 1) return; // No need to stagger single iframe

  // Store sources and clear them (except first one)
  var iframeSources = [];
  iframes.forEach(function(iframe, index) {
    if (index > 0) {
      iframeSources.push({ iframe: iframe, src: iframe.src });
      iframe.src = ''; // Clear src to stop loading
    }
  });

  // Reload iframes one by one with delay
  iframeSources.forEach(function(item, index) {
    setTimeout(function() {
      item.iframe.src = item.src;
    }, (index + 1) * 1500); // 1.5 second delay between each iframe
  });
}

// Run after DOM is ready and after a small delay to let other scripts initialize
jQuery(document).ready(function() {
  // Use setTimeout to ensure this runs after the theme's processCollapsibles function
  setTimeout(init_expanded_sections, 100);
});

// Also run on Shopify section load (for theme editor)
document.addEventListener('shopify:section:load', function() {
  setTimeout(init_expanded_sections, 100);
});

